var _circle, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartiallyProcessed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#CBE4D2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50272_3062)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 20 0)",
    fill: "#34A853"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_50272_3062)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8765 6.03298C16.1993 6.31824 16.2295 6.81172 15.9442 7.13654L9.95795 13.9036C9.88882 13.9818 9.80471 14.0453 9.71062 14.0904C9.61652 14.1355 9.51433 14.1613 9.4101 14.1663C9.30586 14.1712 9.20169 14.1552 9.10374 14.1192C9.00579 14.0832 8.91605 14.028 8.83982 13.9567L4.93573 10.3129C4.78554 10.1714 4.69749 9.97612 4.69084 9.76985C4.68418 9.56358 4.75945 9.36307 4.9002 9.21213C5.04095 9.0612 5.23573 8.97213 5.44196 8.96439C5.64819 8.95665 5.8491 9.03087 6.00077 9.17083L9.32184 12.2629L14.7772 6.09961C14.8452 6.02267 14.9277 5.9599 15.02 5.9149C15.1123 5.8699 15.2126 5.84355 15.3151 5.83736C15.4176 5.83117 15.5203 5.84526 15.6174 5.87883C15.7144 5.9124 15.8039 5.96478 15.8807 6.03298H15.8765Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_50272_3062",
    x: 2.60825,
    y: 3.75376,
    width: 15.6136,
    height: 12.4964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.04109
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_50272_3062"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_50272_3062",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50272_3062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 10 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartiallyProcessed);
export default __webpack_public_path__ + "static/media/partially_processed.e5b4401d07672d6c69d5a4dd4b630e97.svg";
export { ForwardRef as ReactComponent };